/**
 * @param  {Number} number
 * @return {String}
 */
export const prefixNumber = function reduceNumberLengthWithSiPrefix(number, lang = 'en') {
    const postfix = {
        en: {
            billion: ' B',
            million: ' M',
            thousand: 'K',
        },
        ru: {
            billion: ' МЛРД',
            million: ' МЛН',
            thousand: 'K',
        },
    };

    /* eslint padded-blocks: "off", no-else-return: "off" */
    if (number >= 1000000000) {
        return Math.round(number / 10000000) / 100 + postfix[lang].billion;

    } else if (number >= 1000000) {
        return Math.round(number / 100000) / 10 + postfix[lang].million;
    } else if (number > 1000) {
        return Math.round(number / 100) / 10 + postfix[lang].thousand;

    } else if (number === 0) {
        return '0';

    } else if (number < 10) {
        return number.toFixed(2);
    }

    return number;
};
